import { ReactNode } from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

interface AnimatedSectionProps {
  children: ReactNode;
  animation?: 'fade-in' | 'slide-up' | 'slide-left' | 'slide-right' | 'scale-up';
  delay?: number;
  duration?: number;
  className?: string;
  staggerChildren?: boolean;
  staggerDelay?: number;
}

export function AnimatedSection({
  children,
  animation = 'fade-in',
  delay = 0,
  duration = 0.6,
  className = '',
  staggerChildren = false,
  staggerDelay = 0.1,
}: AnimatedSectionProps) {
  const { elementRef, isVisible } = useScrollAnimation();

  const animationClass = isVisible ? `animate-${animation}` : 'opacity-0';
  
  const style = {
    animationDelay: `${delay}s`,
    animationDuration: `${duration}s`,
    animationFillMode: 'both',
  };

  if (staggerChildren) {
    return (
      <div
        ref={elementRef}
        className={`${className} ${isVisible ? 'animate-stagger-children' : 'opacity-0'}`}
        style={{
          ...style,
          ['--stagger-delay' as string]: `${staggerDelay}s`,
        }}
      >
        {children}
      </div>
    );
  }

  return (
    <div
      ref={elementRef}
      className={`${animationClass} ${className}`}
      style={style}
    >
      {children}
    </div>
  );
}
